import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useReference } from '@/core/composables/useReference'
import { toRefs } from 'vue'

interface Props {
  /** Reference object data */
  reference: ReferenceInterface
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceStatusText'
},
  __name: 'ReferenceStatusText',
  props: {
    reference: {}
  },
  setup(__props: any) {

const props = __props



const { reference } = toRefs(props)

const { statusVariant, statusText } = useReference(reference)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["status-text text-xs", `status-text-${_unref(statusVariant)}`])
  }, _toDisplayString(_unref(statusText)), 3))
}
}

})